import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const GavelIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m5.2494 8.0688 2.83-2.8269 14.1343 14.15-2.83 2.8269zm4.2363-4.2415 2.828-2.8289 5.6577 5.656-2.828 2.8289zM.9989 12.3147l2.8284-2.8285 5.6569 5.6569-2.8285 2.8284zM1 21h12v2H1z"
      fill="currentColor"
    />
  </svg>
);

GavelIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(GavelIcon);
